/** @format */

import {validateOrderWithErrors} from 'frontier/ds/quoter/functions/validate';
import {Toast, Modal, ModalHeader, ModalFooter} from '@sttark/design-system';
import {useSavedOrdersContext} from './saved_orders_context_provider';
import {useSave} from 'frontier/components/form/use_save';
import {Button} from '@sttark/design-system';
import {IfElse} from 'frontier-utilities';
import React, {useState} from 'react';

export const AddToCart = props => {
    const {order} = props;

    const ctx = useSavedOrdersContext();

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isToastOpen, setIsToastOpen] = useState(false);
    const [isPending, setIsPending] = useState(false);

    const {save} = useSave('/carts/add-to-cart/' + order.id);

    const handleAddToCart = async () => {
        setIsPending(true);
        setIsModalOpen(false);

        const response = await save();

        if (!!response.body) {
            setIsToastOpen(true);
            // wait for 4 seconds for the toast interaction to finish
            setTimeout(() => {
                ctx.handleRemove(order.id);
                const cartTotal = document.getElementById('cart_total').querySelector('span');
                cartTotal.innerHTML = response.body.cart.order_count;
                setIsPending(false);
            }, 4000);

            if (typeof window.dataLayer !== 'undefined') {
                window.dataLayer.push({
                    order_id: response.body.order.id,
                    cart_id: response.body.cart.id,
                    gtm_user_id: response.body.order.user_id,
                    event: 'addToCart'
                });
            }
        } else {
            setIsPending(false);
        }
    };

    const {isComplete} = validateOrderWithErrors(order);

    if (!isComplete) return null;

    return (
        <>
            <Toast
                onClose={() => setIsToastOpen(false)}
                autoHideDuration={4000}
                isOpen={isToastOpen}
                zIndex={3001}
                autoHide>
                <p className="m-0 p-0 color-structure-white">Added to cart successfully!</p>
            </Toast>
            <Modal onClose={() => setIsModalOpen(false)} isOpen={isModalOpen} bodyHeightAuto>
                <ModalHeader onClose={() => setIsModalOpen(false)}>Add Quote to Cart</ModalHeader>
                <div>
                    <h4 className="mx-0 mb-2 mt-0" style={{fontSize: 18}}>
                        Do you wish to proceed?
                    </h4>
                    <p className="m-0">
                        Adding this Quote to your Cart will remove it from your Saved Quotes
                    </p>
                </div>
                <ModalFooter>
                    <div className="d-flex align-items-center justify-content-end gap-4">
                        <Button
                            onClick={() => setIsModalOpen(false)}
                            label="Cancel"
                            secondary
                            small
                        />
                        <Button
                            label={isPending ? 'Adding to Cart...' : 'Add to Cart'}
                            onClick={handleAddToCart}
                            disabled={isPending}
                            primary
                            small
                        />
                    </div>
                </ModalFooter>
            </Modal>
            <IfElse condition={isPending}>
                <button
                    className="p-0 mx-0 mt-0 mb-2 color-structure-darker d-flex align-items-center justify-content-center gap-2"
                    disabled="disabled">
                    <i className="fas fa-spin fa-spinner" />
                    <u>Adding to cart...</u>
                </button>
                <button
                    className="p-0 mx-0 mt-0 mb-2 color-accent-primary d-flex align-items-center justify-content-center gap-2"
                    onClick={() => setIsModalOpen(true)}>
                    <i className="fas fa-shopping-cart" />
                    <u>Add to Cart</u>
                </button>
            </IfElse>
        </>
    );
};
